import { gsap } from 'gsap';

export default {

	init() {
		const buttons = Array.from(document.querySelectorAll('.panel__header button'));
		buttons.forEach(button => button.addEventListener('click', this.buttonClick));
	},

	buttonClick(event) {
		const panel = event.currentTarget.closest('.panel');
		const body = panel.querySelector('.panel__body');
		const bounds = body.getBoundingClientRect();
		const oldHeight = bounds.height;
		const newHeight = oldHeight ? 0 : 'auto';
		gsap.set(body, { height: newHeight });
		gsap.from(body, { height: oldHeight, duration: 0.5 });
		panel.classList.toggle('is-active');
	},

};
